export const translation = {
    'multipleSystems': 'Multiple connected Systems seem to be degraded. Please contact your Systemadministrator.',
    'keycloak-user-management-health': 'The connected Keycloak system reports a problem.',
    'maintenance': {
        title: 'Pardon us while we freshen up.',
        body: 'Our servers are currently down for maintenance. Come back soon to see the new improvements! (This usually takes less than an hour)'
    },
    'suspended': {
        title: 'Instance in suspend mode.',
        body: "We put this instance temporarily in suspend mode. This is most likely because of an issue with your payment. Please don't worry. If you think this is an error, we are here to assist you in resolving this matter.<br> <email>Please reach out to our service team.</email> <br>Your data remains safe and secure during this period. We understand how crucial your data is, and we want to assure you that we will retain it for an additional 30 days. This gives you ample time to rectify the situation and ensure uninterrupted access to your valuable information."
    }
};
